import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import { gapi } from "gapi-script";
import { useGoogleLogin } from "@react-oauth/google";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import Loader from "../Loader";
import { uploadDocument } from "../../store/reducers/uploadDocumentSlice";

const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
const API_KEY = process.env.REACT_APP_GOOGLE_PICKER_KEY;
const SCOPES = "https://www.googleapis.com/auth/drive.readonly";
const DISCOVERY_DOCS = ["https://www.googleapis.com/discovery/v1/apis/drive/v3/rest"];

const GoogleDrivePicker = () => {
  const dispatch = useDispatch();
  const [pickerLoaded, setPickerLoaded] = useState(false);
  const [accessToken, setAccessToken] = useState("");
  const [loader, setLoader] = useState(false);
  const { pdfEditortoken } = useSelector((state) => state.pdfEditortoken);

  useEffect(() => {
    const initializeGapi = async () => {
      gapi.load("client:auth2", async () => {
        await gapi.client.init({
          apiKey: API_KEY,
          discoveryDocs: DISCOVERY_DOCS,
        });
  
        gapi.load("picker", () => setPickerLoaded(true));
      });
    };
    initializeGapi();
  }, []);  

  const googleLogin = useGoogleLogin({
    scope: SCOPES,
    onSuccess: (tokenResponse) => {
      console.log('tokenResponse',tokenResponse?.access_token)
      setAccessToken(tokenResponse?.access_token);
      openPicker(tokenResponse.access_token);
    },
    onError: () => alert("Google login failed. Please try again."),
  });

  const handleUploadClick = () => {
    if (!accessToken) {
      googleLogin();
    } else {
      openPicker(accessToken);
    }
  };

  const openPicker = (token) => {
    if (!pickerLoaded) {
      alert("Google Picker is not loaded yet.");
      return;
    }

    const view = new window.google.picker.DocsView()
    .setIncludeFolders(false)
    .setMimeTypes("application/pdf") // only show PDF files
    .setSelectFolderEnabled(false);
    const picker = new window.google.picker.PickerBuilder()
      .setOAuthToken(token)
      .addView(view)
      .setDeveloperKey(API_KEY)
      .setCallback((data) => handlePickerCallback(data, token))
      .build();
    picker.setVisible(true);
  };

  const handlePickerCallback = async (data, token) => {
    if (data.action === window.google.picker.Action.PICKED) {
      const fileId = data.docs[0].id;
      console.log("Selected File ID:", fileId, token);
  
      if (!token) {
        alert("Access token not available.");
        return;
      }
  
      try {
        const response = await fetch(`https://www.googleapis.com/drive/v3/files/${fileId}?alt=media`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
  
        if (!response.ok) {
          throw new Error(`Google API error: ${response.status}`);
        }
  
        const fileBlob = await response.blob();
        uploadToServer(fileBlob, data.docs[0].name);
      } catch (error) {
        console.error("Error fetching file via fetch:", error);
        alert("Failed to fetch file from Google Drive. Try logging in again.");
      }
    }
  };  

  const uploadToServer = async (file, fileName) => {
    const formData = new FormData();
    formData.append("file", file, fileName);
    try {
      setLoader(true)
      dispatch(uploadDocument({ token: pdfEditortoken?.access, file, fileName:fileName }));
    } catch (error) {
      console.error("File upload failed:", error);
    }
  };

  return (<>
    <Box textAlign="center" onClick={handleUploadClick} sx={{ cursor: "pointer" }}>
      <Box component="img" src={`${process.env.PUBLIC_URL}/images/google-drive.svg`} alt="Google Drive" />
      <Typography variant="body1" fontSize={14} fontWeight={500} mt={1} color="#222222">
        Google Drive
      </Typography>
    </Box>
    {loader && < Loader />}
    </>
  );
};

export default GoogleDrivePicker;
